export default __webpack_public_path__ + "static/media/food_complexcarbs.13882f8a.png";